import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  StringFormat2r2ka8mzcb3mi as StringFormat,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1x79l67jvwntn as serializer,
  InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor,
  SerializableWithd2dap36updxd as SerializableWith,
  SEALED_getInstance2pc3convncp73 as SEALED_getInstance,
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  STRING_getInstance1ov5zayfui8fl as STRING_getInstance,
  ENUM_getInstance1f3d4zr61j5rk as ENUM_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  serializer2lw83vwvpnyms as serializer_0,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
  ElementMarker33ojvsajwmzts as ElementMarker,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  CLASS_getInstance3ax1g1upf6nuo as CLASS_getInstance,
  LIST_getInstance2xmlsct1exo3w as LIST_getInstance,
  CONTEXTUAL_getInstance2bsxm25kydylq as CONTEXTUAL_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance173r3f2itu405 as MAP_getInstance,
  ENUMlmq49cvwy4ow as ENUM,
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  MissingFieldException24tqif29emcmi as MissingFieldException,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  OBJECT_getInstance2hwgzvvdc8p80 as OBJECT_getInstance,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  serializer3ikrxnm8b29d6 as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1q7c5q67ysppr as serializer_3,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_0,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  StringBuildermazzzhj6kkai as StringBuilder,
  hashCodeq5arwsb9dgti as hashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toDouble1kn912gjoizjp as toDouble,
  StringCompanionObject_instance3btc7up7fjjpg as StringCompanionObject_instance,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toULongOrNullojoyxi0i9tgj as toULongOrNull,
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstancehe6v7kxreu2f as Companion_getInstance,
  _ULong___get_data__impl__fggpzb35t7vg7og3i8u as _ULong___get_data__impl__fggpzb,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
  lazy2hsh8ze7j6ikd as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  fromInt1lka3ktyu79a4 as fromInt,
  _UInt___init__impl__l7qpdl2rn8hu5x5mgv2 as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl21yokvu77tk3i9 as UInt__toString_impl_dbgl21,
  _ULong___init__impl__c78o9k3fkiaf1q5xsf7 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7km926x5dlwl9j as ULong__toString_impl_f9au7k,
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg7h00k2smi73g as UByte__toString_impl_v72jg,
  _UShort___init__impl__jigrne1zu56ujvuii2n as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee309dhgco6do74 as UShort__toString_impl_edaoee,
  captureStack1fzi4aczwc4hg as captureStack,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Collection1k04j3hzsbod0 as Collection,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  ArrayList3it5z8td81qkl as ArrayList,
  singleOrNullrknfaxokm1sl as singleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
  copyOf2ng0t8oizk6it as copyOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  getKClass3t8tygqu4lcxf as getKClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
  plus17rl43at52ays as plus,
  convertToByte1epqhkuyxuz5a as convertToByte,
  equalsLong28bsrfhwvd686 as equalsLong,
  convertToShortvtefcftm709c as convertToShort,
  convertToIntofdoxh9bstof as convertToInt,
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
  charCodeAt1yspne1d8erbm as charCodeAt,
  toUInt21lx0mz8wkp7c as toUInt,
  _UInt___get_data__impl__f0vqqw18g8a2o14g87q as _UInt___get_data__impl__f0vqqw,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
  toUShort7yqspfnhrot4 as toUShort,
  _UShort___get_data__impl__g02451joe1vsk2vach as _UShort___get_data__impl__g0245,
  toString336ienavfnzn0 as toString_1,
  Companion_getInstance2bqk1h54tdzgh as Companion_getInstance_0,
  Companion_getInstance29en1y99grgx1 as Companion_getInstance_1,
  Companion_getInstancehpp5w6ty1u0b as Companion_getInstance_2,
  setOf45ia9pnfhe90 as setOf,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  equals2v6cggk171b6e as equals_0,
  toByte4i43936u611k as toByte,
  startsWith26w8qjqapeeq6 as startsWith,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains_0,
  single29ec4rh52687r as single,
  Char19o2r8palgjof as Char,
  emptySetcxexqki71qfa as emptySet,
  plus1ogy4liedzq5j as plus_0,
  toInt2q8uldh7sc951 as toInt,
  toList3jhuyej2anx2q as toList,
  enumEntries20mr21zbe3az4 as enumEntries,
  toNumberlmbpvqo27r53 as toNumber,
  last1vo29oleiqj36 as last,
  removeLast3759euu1xvfa3 as removeLast,
  lastIndexOf2d52xhix5ymjr as lastIndexOf,
  Long2qws0ah9gnpki as Long,
  Char__minus_impl_a2frrh370khreoakmi6 as Char__minus_impl_a2frrh,
  multiply18i3gv3wlmcjg as multiply,
  add85si75olwt6n as add,
  subtract16cg4lfi29fq9 as subtract,
  compare2uud5j30pw5xc as compare,
  numberToLong345n6tb1n1i71 as numberToLong,
  negate12tprdg5pyd5t as negate,
  charArray2ujmm1qusno00 as charArray,
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
  substringiqarkczpya5m as substring,
  HashMap1a0ld5kgwhmhv as HashMap,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Json {
  constructor(configuration, serializersModule) {
    Default_getInstance();
    this.p2d_1 = configuration;
    this.q2d_1 = serializersModule;
    this.r2d_1 = new DescriptorSchemaCache();
  }
  l10() {
    return this.q2d_1;
  }
  m10(serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.a2b();
    }
  }
  n10(deserializer, string) {
    var lexer = StringJsonLexer_0(this, string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.dz(), null);
    var result = input.o13(deserializer);
    lexer.f2e();
    return result;
  }
}
class Default extends Json {
  constructor() {
    Default_instance = null;
    super(new JsonConfiguration(), EmptySerializersModule());
    Default_instance = this;
  }
}
class JsonBuilder {
  constructor(json) {
    this.g2e_1 = json.p2d_1.z2e_1;
    this.h2e_1 = json.p2d_1.e2f_1;
    this.i2e_1 = json.p2d_1.a2f_1;
    this.j2e_1 = json.p2d_1.b2f_1;
    this.k2e_1 = json.p2d_1.d2f_1;
    this.l2e_1 = json.p2d_1.f2f_1;
    this.m2e_1 = json.p2d_1.g2f_1;
    this.n2e_1 = json.p2d_1.i2f_1;
    this.o2e_1 = json.p2d_1.p2f_1;
    this.p2e_1 = json.p2d_1.k2f_1;
    this.q2e_1 = json.p2d_1.l2f_1;
    this.r2e_1 = json.p2d_1.m2f_1;
    this.s2e_1 = json.p2d_1.n2f_1;
    this.t2e_1 = json.p2d_1.o2f_1;
    this.u2e_1 = json.p2d_1.j2f_1;
    this.v2e_1 = json.p2d_1.c2f_1;
    this.w2e_1 = json.p2d_1.h2f_1;
    this.x2e_1 = json.l10();
  }
  y2e() {
    if (this.w2e_1) {
      // Inline function 'kotlin.require' call
      if (!(this.n2e_1 === 'type')) {
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException.h2(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!this.o2e_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException.h2(toString(message_0));
      }
    }
    if (!this.k2e_1) {
      // Inline function 'kotlin.require' call
      if (!(this.l2e_1 === '    ')) {
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException.h2(toString(message_1));
      }
    } else if (!(this.l2e_1 === '    ')) {
      var tmp0 = this.l2e_1;
      var tmp$ret$6;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(tmp0)) {
          var element = charSequenceGet(tmp0, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$6 = false;
            break $l$block;
          }
        }
        tmp$ret$6 = true;
      }
      var allWhitespaces = tmp$ret$6;
      // Inline function 'kotlin.require' call
      if (!allWhitespaces) {
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.l2e_1;
        throw IllegalArgumentException.h2(toString(message_2));
      }
    }
    return new JsonConfiguration(this.g2e_1, this.i2e_1, this.j2e_1, this.v2e_1, this.k2e_1, this.h2e_1, this.l2e_1, this.m2e_1, this.w2e_1, this.n2e_1, this.u2e_1, this.p2e_1, this.q2e_1, this.r2e_1, this.s2e_1, this.t2e_1, this.o2e_1);
  }
}
class JsonImpl extends Json {
  constructor(configuration, module_0) {
    super(configuration, module_0);
    validateConfiguration(this);
  }
}
class JsonClassDiscriminator {}
class JsonIgnoreUnknownKeys {}
class JsonNames {}
class JsonConfiguration {
  constructor(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    allowComments = allowComments === VOID ? false : allowComments;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.z2e_1 = encodeDefaults;
    this.a2f_1 = ignoreUnknownKeys;
    this.b2f_1 = isLenient;
    this.c2f_1 = allowStructuredMapKeys;
    this.d2f_1 = prettyPrint;
    this.e2f_1 = explicitNulls;
    this.f2f_1 = prettyPrintIndent;
    this.g2f_1 = coerceInputValues;
    this.h2f_1 = useArrayPolymorphism;
    this.i2f_1 = classDiscriminator;
    this.j2f_1 = allowSpecialFloatingPointValues;
    this.k2f_1 = useAlternativeNames;
    this.l2f_1 = namingStrategy;
    this.m2f_1 = decodeEnumsCaseInsensitive;
    this.n2f_1 = allowTrailingComma;
    this.o2f_1 = allowComments;
    this.p2f_1 = classDiscriminatorMode;
  }
  toString() {
    return 'JsonConfiguration(encodeDefaults=' + this.z2e_1 + ', ignoreUnknownKeys=' + this.a2f_1 + ', isLenient=' + this.b2f_1 + ', ' + ('allowStructuredMapKeys=' + this.c2f_1 + ', prettyPrint=' + this.d2f_1 + ', explicitNulls=' + this.e2f_1 + ', ') + ("prettyPrintIndent='" + this.f2f_1 + "', coerceInputValues=" + this.g2f_1 + ', useArrayPolymorphism=' + this.h2f_1 + ', ') + ("classDiscriminator='" + this.i2f_1 + "', allowSpecialFloatingPointValues=" + this.j2f_1 + ', ') + ('useAlternativeNames=' + this.k2f_1 + ', namingStrategy=' + toString_0(this.l2f_1) + ', decodeEnumsCaseInsensitive=' + this.m2f_1 + ', ') + ('allowTrailingComma=' + this.n2f_1 + ', allowComments=' + this.o2f_1 + ', classDiscriminatorMode=' + this.p2f_1.toString() + ')');
  }
}
class ClassDiscriminatorMode extends Enum {}
class JsonDecoder {}
class Companion {}
class JsonElement {}
class Companion_0 {}
class JsonPrimitive extends JsonElement {
  toString() {
    return this.s2f();
  }
}
class Companion_1 {}
class JsonObject extends JsonElement {
  constructor(content) {
    super();
    this.t2f_1 = content;
  }
  equals(other) {
    return equals(this.t2f_1, other);
  }
  hashCode() {
    return hashCode(this.t2f_1);
  }
  toString() {
    var tmp = this.t2f_1.i3();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  }
  n1() {
    return this.t2f_1.n1();
  }
  u2f(key) {
    return this.t2f_1.u4(key);
  }
  u4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.u2f((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  wi(key) {
    return this.t2f_1.w4(key);
  }
  w4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.wi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  s2() {
    return this.t2f_1.s2();
  }
  x4() {
    return this.t2f_1.x4();
  }
  y4() {
    return this.t2f_1.y4();
  }
  i3() {
    return this.t2f_1.i3();
  }
}
class Companion_2 {}
class JsonArray extends JsonElement {
  constructor(content) {
    super();
    this.v2f_1 = content;
  }
  equals(other) {
    return equals(this.v2f_1, other);
  }
  hashCode() {
    return hashCode(this.v2f_1);
  }
  toString() {
    return joinToString(this.v2f_1, ',', '[', ']');
  }
  n1() {
    return this.v2f_1.n1();
  }
  w2f(element) {
    return this.v2f_1.w2(element);
  }
  w2(element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.w2f(element instanceof JsonElement ? element : THROW_CCE());
  }
  p1() {
    return this.v2f_1.p1();
  }
  x2f(elements) {
    return this.v2f_1.r4(elements);
  }
  r4(elements) {
    return this.x2f(elements);
  }
  u2(index) {
    return this.v2f_1.u2(index);
  }
  y2f(element) {
    return this.v2f_1.y2(element);
  }
  y2(element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.y2f(element instanceof JsonElement ? element : THROW_CCE());
  }
  s4() {
    return this.v2f_1.s4();
  }
  x2(index) {
    return this.v2f_1.x2(index);
  }
  t4(fromIndex, toIndex) {
    return this.v2f_1.t4(fromIndex, toIndex);
  }
  s2() {
    return this.v2f_1.s2();
  }
}
class JsonNull extends JsonPrimitive {
  constructor() {
    JsonNull_instance = null;
    super();
    JsonNull_instance = this;
    this.z2f_1 = 'null';
  }
  s2f() {
    return this.z2f_1;
  }
  a2g() {
    return JsonNullSerializer_getInstance();
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class JsonLiteral extends JsonPrimitive {
  constructor(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    super();
    this.b2g_1 = isString;
    this.c2g_1 = coerceToInlineType;
    this.d2g_1 = toString(body);
    if (!(this.c2g_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!this.c2g_1.x11()) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException.h2(toString(message));
      }
    }
  }
  s2f() {
    return this.d2g_1;
  }
  toString() {
    var tmp;
    if (this.b2g_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder.l1();
      printQuoted(this_0, this.d2g_1);
      tmp = this_0.toString();
    } else {
      tmp = this.d2g_1;
    }
    return tmp;
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.b2g_1 === other.b2g_1))
      return false;
    if (!(this.d2g_1 === other.d2g_1))
      return false;
    return true;
  }
  hashCode() {
    var result = getBooleanHashCode(this.b2g_1);
    result = imul(31, result) + getStringHashCode(this.d2g_1) | 0;
    return result;
  }
}
class JsonElementSerializer {
  constructor() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.k2g_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  dz() {
    return this.k2g_1;
  }
  l2g(encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.h15(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.h15(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.h15(JsonArraySerializer_getInstance(), value);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  ez(encoder, value) {
    return this.l2g(encoder, value instanceof JsonElement ? value : THROW_CCE());
  }
  fz(decoder) {
    var input = asJsonDecoder(decoder);
    return input.r2f();
  }
}
class JsonPrimitiveSerializer {
  constructor() {
    JsonPrimitiveSerializer_instance = this;
    this.f2g_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  dz() {
    return this.f2g_1;
  }
  m2g(encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.h15(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.h15(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  }
  ez(encoder, value) {
    return this.m2g(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  }
  fz(decoder) {
    var result = asJsonDecoder(decoder).r2f();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  }
}
class JsonNullSerializer {
  constructor() {
    JsonNullSerializer_instance = this;
    this.g2g_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  dz() {
    return this.g2g_1;
  }
  n2g(encoder, value) {
    verify(encoder);
    encoder.k14();
  }
  ez(encoder, value) {
    return this.n2g(encoder, value instanceof JsonNull ? value : THROW_CCE());
  }
  fz(decoder) {
    verify_0(decoder);
    if (decoder.a13()) {
      throw JsonDecodingException.u2g("Expected 'null' literal");
    }
    decoder.b13();
    return JsonNull_getInstance();
  }
}
class JsonLiteralSerializer {
  constructor() {
    JsonLiteralSerializer_instance = this;
    this.h2g_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  dz() {
    return this.h2g_1;
  }
  v2g(encoder, value) {
    verify(encoder);
    if (value.b2g_1) {
      return encoder.t14(value.d2g_1);
    }
    if (!(value.c2g_1 == null)) {
      return encoder.v14(value.c2g_1).t14(value.d2g_1);
    }
    var tmp0_safe_receiver = toLongOrNull(value.d2g_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.p14(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.d2g_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).ly_1;
      var tmp_1 = encoder.v14(serializer_0(Companion_getInstance()).dz());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$4 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.p14(tmp$ret$4);
      return Unit_instance;
    }
    var tmp2_safe_receiver = toDoubleOrNull(value.d2g_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.r14(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toBooleanStrictOrNull(value.d2g_1);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.l14(tmp3_safe_receiver);
    }
    encoder.t14(value.d2g_1);
  }
  ez(encoder, value) {
    return this.v2g(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  }
  fz(decoder) {
    var result = asJsonDecoder(decoder).r2f();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  }
}
class JsonObjectDescriptor {
  constructor() {
    JsonObjectDescriptor_instance = this;
    this.w2g_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).dz();
    this.x2g_1 = 'kotlinx.serialization.json.JsonObject';
  }
  g10() {
    return this.x2g_1;
  }
  a12(index) {
    return this.w2g_1.a12(index);
  }
  b12(name) {
    return this.w2g_1.b12(name);
  }
  c12(index) {
    return this.w2g_1.c12(index);
  }
  d12(index) {
    return this.w2g_1.d12(index);
  }
  e12(index) {
    return this.w2g_1.e12(index);
  }
  w11() {
    return this.w2g_1.w11();
  }
  p11() {
    return this.w2g_1.p11();
  }
  x11() {
    return this.w2g_1.x11();
  }
  y11() {
    return this.w2g_1.y11();
  }
  z11() {
    return this.w2g_1.z11();
  }
}
class JsonObjectSerializer {
  constructor() {
    JsonObjectSerializer_instance = this;
    this.i2g_1 = JsonObjectDescriptor_getInstance();
  }
  dz() {
    return this.i2g_1;
  }
  y2g(encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).ez(encoder, value);
  }
  ez(encoder, value) {
    return this.y2g(encoder, value instanceof JsonObject ? value : THROW_CCE());
  }
  fz(decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).fz(decoder));
  }
}
class JsonArrayDescriptor {
  constructor() {
    JsonArrayDescriptor_instance = this;
    this.z2g_1 = ListSerializer(JsonElementSerializer_getInstance()).dz();
    this.a2h_1 = 'kotlinx.serialization.json.JsonArray';
  }
  g10() {
    return this.a2h_1;
  }
  a12(index) {
    return this.z2g_1.a12(index);
  }
  b12(name) {
    return this.z2g_1.b12(name);
  }
  c12(index) {
    return this.z2g_1.c12(index);
  }
  d12(index) {
    return this.z2g_1.d12(index);
  }
  e12(index) {
    return this.z2g_1.e12(index);
  }
  w11() {
    return this.z2g_1.w11();
  }
  p11() {
    return this.z2g_1.p11();
  }
  x11() {
    return this.z2g_1.x11();
  }
  y11() {
    return this.z2g_1.y11();
  }
  z11() {
    return this.z2g_1.z11();
  }
}
class JsonArraySerializer {
  constructor() {
    JsonArraySerializer_instance = this;
    this.j2g_1 = JsonArrayDescriptor_getInstance();
  }
  dz() {
    return this.j2g_1;
  }
  b2h(encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).ez(encoder, value);
  }
  ez(encoder, value) {
    return this.b2h(encoder, value instanceof JsonArray ? value : THROW_CCE());
  }
  fz(decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).fz(decoder));
  }
}
class defer$1 {
  constructor($deferred) {
    this.c2h_1 = lazy($deferred);
  }
  g10() {
    return _get_original__l7ku1m(this).g10();
  }
  w11() {
    return _get_original__l7ku1m(this).w11();
  }
  y11() {
    return _get_original__l7ku1m(this).y11();
  }
  a12(index) {
    return _get_original__l7ku1m(this).a12(index);
  }
  b12(name) {
    return _get_original__l7ku1m(this).b12(name);
  }
  c12(index) {
    return _get_original__l7ku1m(this).c12(index);
  }
  d12(index) {
    return _get_original__l7ku1m(this).d12(index);
  }
  e12(index) {
    return _get_original__l7ku1m(this).e12(index);
  }
}
class JsonEncoder {}
class Composer {
  constructor(writer) {
    this.d2h_1 = writer;
    this.e2h_1 = true;
  }
  f2h() {
    this.e2h_1 = true;
  }
  g2h() {
    return Unit_instance;
  }
  h2h() {
    this.e2h_1 = false;
  }
  i2h() {
    this.e2h_1 = false;
  }
  j2h() {
    return Unit_instance;
  }
  k2h(v) {
    return this.d2h_1.l2h(v);
  }
  m2h(v) {
    return this.d2h_1.n2h(v);
  }
  o2h(v) {
    return this.d2h_1.n2h(v.toString());
  }
  p2h(v) {
    return this.d2h_1.n2h(v.toString());
  }
  q2h(v) {
    return this.d2h_1.r2h(fromInt(v));
  }
  s2h(v) {
    return this.d2h_1.r2h(fromInt(v));
  }
  t2h(v) {
    return this.d2h_1.r2h(fromInt(v));
  }
  u2h(v) {
    return this.d2h_1.r2h(v);
  }
  v2h(v) {
    return this.d2h_1.n2h(v.toString());
  }
  w2h(value) {
    return this.d2h_1.x2h(value);
  }
}
class ComposerForUnsignedNumbers extends Composer {
  constructor(writer, forceQuoting) {
    super(writer);
    this.a2i_1 = forceQuoting;
  }
  t2h(v) {
    if (this.a2i_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.w2h(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.m2h(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  }
  u2h(v) {
    if (this.a2i_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.w2h(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.m2h(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  }
  q2h(v) {
    if (this.a2i_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.w2h(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.m2h(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  }
  s2h(v) {
    if (this.a2i_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.w2h(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.m2h(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  }
}
class ComposerForUnquotedLiterals extends Composer {
  constructor(writer, forceQuoting) {
    super(writer);
    this.d2i_1 = forceQuoting;
  }
  w2h(value) {
    if (this.d2i_1) {
      super.w2h(value);
    } else {
      super.m2h(value);
    }
  }
}
class ComposerWithPrettyPrint extends Composer {
  constructor(writer, json) {
    super(writer);
    this.g2i_1 = json;
    this.h2i_1 = 0;
  }
  f2h() {
    this.e2h_1 = true;
    this.h2i_1 = this.h2i_1 + 1 | 0;
  }
  g2h() {
    this.h2i_1 = this.h2i_1 - 1 | 0;
  }
  h2h() {
    this.e2h_1 = false;
    this.m2h('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.h2i_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.m2h(this.g2i_1.p2d_1.f2f_1);
      }
       while (inductionVariable < times);
  }
  i2h() {
    if (this.e2h_1)
      this.e2h_1 = false;
    else {
      this.h2h();
    }
  }
  j2h() {
    this.k2h(_Char___init__impl__6a9atx(32));
  }
}
class JsonElementMarker {
  constructor(descriptor) {
    var tmp = this;
    tmp.i2i_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.j2i_1 = false;
  }
  k2i(index) {
    this.i2i_1.x19(index);
  }
  l2i() {
    return this.i2i_1.y19();
  }
}
class JsonException extends SerializationException {
  constructor(message) {
    return new.target.r2i(message);
  }
  static r2i(message) {
    var $this = this.y10(message);
    captureStack($this, $this.q2i_1);
    return $this;
  }
}
class JsonDecodingException extends JsonException {
  constructor(message) {
    return new.target.u2g(message);
  }
  static u2g(message) {
    var $this = this.r2i(message);
    captureStack($this, $this.t2g_1);
    return $this;
  }
}
class JsonEncodingException extends JsonException {
  constructor(message) {
    return new.target.a2j(message);
  }
  static a2j(message) {
    var $this = this.r2i(message);
    captureStack($this, $this.z2i_1);
    return $this;
  }
}
class Tombstone {}
class JsonPath {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.f2j_1 = Array(8);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.g2j_1 = tmp_2;
    this.h2j_1 = -1;
  }
  i2j(sd) {
    this.h2j_1 = this.h2j_1 + 1 | 0;
    var depth = this.h2j_1;
    if (depth === this.f2j_1.length) {
      resize(this);
    }
    this.f2j_1[depth] = sd;
  }
  j2j(index) {
    this.g2j_1[this.h2j_1] = index;
  }
  k2j(key) {
    var tmp;
    if (!(this.g2j_1[this.h2j_1] === -2)) {
      this.h2j_1 = this.h2j_1 + 1 | 0;
      tmp = this.h2j_1 === this.f2j_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.f2j_1[this.h2j_1] = key;
    this.g2j_1[this.h2j_1] = -2;
  }
  l2j() {
    if (this.g2j_1[this.h2j_1] === -2) {
      this.f2j_1[this.h2j_1] = Tombstone_instance;
    }
  }
  m2j() {
    var depth = this.h2j_1;
    if (this.g2j_1[depth] === -2) {
      this.g2j_1[depth] = -1;
      this.h2j_1 = this.h2j_1 - 1 | 0;
    }
    if (!(this.h2j_1 === -1)) {
      this.h2j_1 = this.h2j_1 - 1 | 0;
    }
  }
  n2j() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('$');
    // Inline function 'kotlin.repeat' call
    var times = this.h2j_1 + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = this.f2j_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.w11(), LIST_getInstance())) {
            if (!(this.g2j_1[index] === -1)) {
              this_0.m1('[');
              this_0.kh(this.g2j_1[index]);
              this_0.m1(']');
            }
          } else {
            var idx = this.g2j_1[index];
            if (idx >= 0) {
              this_0.m1('.');
              this_0.m1(element.a12(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.m1('[');
            this_0.m1("'");
            this_0.s1(element);
            this_0.m1("'");
            this_0.m1(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  }
  toString() {
    return this.n2j();
  }
}
class JsonSerializersModuleValidator {
  constructor(configuration) {
    this.o2j_1 = configuration.i2f_1;
    this.p2j_1 = configuration.h2f_1;
    this.q2j_1 = !configuration.p2f_1.equals(ClassDiscriminatorMode_NONE_getInstance());
  }
  o1k(kClass, provider) {
  }
  r1k(baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.dz();
    checkKind(this, descriptor, actualClass);
    if (!this.p2j_1 && this.q2j_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  }
  s1k(baseClass, defaultSerializerProvider) {
  }
  t1k(baseClass, defaultDeserializerProvider) {
  }
}
class JsonTreeReader {
  constructor(configuration, lexer) {
    this.b2k_1 = lexer;
    this.c2k_1 = configuration.b2f_1;
    this.d2k_1 = configuration.n2f_1;
    this.e2k_1 = 0;
  }
  k2k() {
    var token = this.b2k_1.g2k();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.e2k_1 = this.e2k_1 + 1 | 0;
      if (this.e2k_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.e2k_1 = this.e2k_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.b2k_1.t2i('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  }
}
class Key {}
class DescriptorSchemaCache {
  constructor() {
    this.b2j_1 = createMapForCache(16);
  }
  n2k(descriptor, key, value) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.b2j_1;
    var value_0 = this_0.w4(descriptor);
    var tmp;
    if (value_0 == null) {
      var answer = createMapForCache(2);
      this_0.b5(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var tmp0 = tmp;
    var tmp2 = key instanceof Key ? key : THROW_CCE();
    // Inline function 'kotlin.collections.set' call
    var value_1 = !(value == null) ? value : THROW_CCE();
    tmp0.b5(tmp2, value_1);
  }
  c2j(descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.o2k(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.n2k(descriptor, key, value);
    return value;
  }
  o2k(descriptor, key) {
    var tmp0_safe_receiver = this.b2j_1.w4(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.w4(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  }
}
class DiscriminatorHolder {
  constructor(discriminatorToSkip) {
    this.p2k_1 = discriminatorToSkip;
  }
}
class StreamingJsonDecoder extends AbstractDecoder {
  constructor(json, mode, lexer, descriptor, discriminatorHolder) {
    super();
    this.t2d_1 = json;
    this.u2d_1 = mode;
    this.v2d_1 = lexer;
    this.w2d_1 = this.t2d_1.l10();
    this.x2d_1 = -1;
    this.y2d_1 = discriminatorHolder;
    this.z2d_1 = this.t2d_1.p2d_1;
    this.a2e_1 = this.z2d_1.e2f_1 ? null : new JsonElementMarker(descriptor);
  }
  q2f() {
    return this.t2d_1;
  }
  l10() {
    return this.w2d_1;
  }
  r2f() {
    return (new JsonTreeReader(this.t2d_1.p2d_1, this.v2d_1)).k2k();
  }
  o13(deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.t2d_1.p2d_1.h2f_1;
      }
      if (tmp) {
        return deserializer.fz(this);
      }
      var discriminator = classDiscriminator(deserializer.dz(), this.t2d_1);
      var tmp0_elvis_lhs = this.v2d_1.y2k(discriminator, this.z2d_1.b2f_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp2 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var tmp_1;
          if (!(tmp2 instanceof AbstractPolymorphicSerializer)) {
            tmp_1 = true;
          } else {
            tmp_1 = this.q2f().p2d_1.h2f_1;
          }
          if (tmp_1) {
            tmp$ret$0 = tmp2.fz(this);
            break $l$block;
          }
          var discriminator_0 = classDiscriminator(tmp2.dz(), this.q2f());
          var tmp0 = this.r2f();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = tmp2.dz().g10();
          if (!(tmp0 instanceof JsonObject)) {
            var tmp_2 = getKClass(JsonObject).j1();
            var tmp_3 = getKClassFromExpression(tmp0).j1();
            var tmp$ret$2 = this.v2d_1.c2e_1.n2j();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp0));
          }
          var jsonTree = tmp0;
          var tmp0_safe_receiver = jsonTree.wi(discriminator_0);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
          var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
          var tmp_4;
          try {
            tmp_4 = findPolymorphicSerializer(tmp2, this, type);
          } catch ($p) {
            var tmp_5;
            if ($p instanceof SerializationException) {
              var it = $p;
              throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
            } else {
              throw $p;
            }
          }
          var tmp_6 = tmp_4;
          var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.q2f(), discriminator_0, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type_0 = tmp_0;
      var tmp_7;
      try {
        tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
      } catch ($p_0) {
        var tmp_8;
        if ($p_0 instanceof SerializationException) {
          var it_0 = $p_0;
          var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
          this.v2d_1.t2i(message, VOID, hint);
        } else {
          throw $p_0;
        }
        tmp_7 = tmp_8;
      }
      var tmp_9 = tmp_7;
      var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
      this.y2d_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer_0.fz(this);
    } catch ($p_1) {
      if ($p_1 instanceof MissingFieldException) {
        var e = $p_1;
        if (contains(ensureNotNull(e.message), 'at path'))
          throw e;
        throw MissingFieldException.i11(e.g11_1, plus(e.message, ' at path: ') + this.v2d_1.c2e_1.n2j(), e);
      } else {
        throw $p_1;
      }
    }
  }
  p13(descriptor) {
    var newMode = switchMode(this.t2d_1, descriptor);
    this.v2d_1.c2e_1.i2j(descriptor);
    this.v2d_1.q2k(newMode.b2l_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.w1_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.t2d_1, newMode, this.v2d_1, descriptor, this.y2d_1);
        break;
      default:
        var tmp_0;
        if (this.u2d_1.equals(newMode) && this.t2d_1.p2d_1.e2f_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.t2d_1, newMode, this.v2d_1, descriptor, this.y2d_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  q13(descriptor) {
    if (descriptor.y11() === 0 && ignoreUnknownKeys(descriptor, this.t2d_1)) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.v2d_1.r2k() && !this.t2d_1.p2d_1.n2f_1) {
      invalidTrailingComma(this.v2d_1, '');
    }
    this.v2d_1.q2k(this.u2d_1.c2l_1);
    this.v2d_1.c2e_1.m2j();
  }
  a13() {
    var tmp;
    var tmp0_safe_receiver = this.a2e_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j2i_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.v2d_1.d2l();
    } else {
      tmp = false;
    }
    return tmp;
  }
  b13() {
    return null;
  }
  b14(descriptor, index, deserializer, previousValue) {
    var isMapKey = this.u2d_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.v2d_1.c2e_1.l2j();
    }
    var value = super.b14(descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.v2d_1.c2e_1.k2j(value);
    }
    return value;
  }
  f14(descriptor) {
    var index;
    switch (this.u2d_1.w1_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.u2d_1.equals(WriteMode_MAP_getInstance())) {
      this.v2d_1.c2e_1.j2j(index);
    }
    return index;
  }
  c13() {
    return this.v2d_1.e2l();
  }
  d13() {
    var value = this.v2d_1.f2l();
    if (!equalsLong(value, fromInt(convertToByte(value)))) {
      this.v2d_1.t2i("Failed to parse byte for input '" + value.toString() + "'");
    }
    return convertToByte(value);
  }
  e13() {
    var value = this.v2d_1.f2l();
    if (!equalsLong(value, fromInt(convertToShort(value)))) {
      this.v2d_1.t2i("Failed to parse short for input '" + value.toString() + "'");
    }
    return convertToShort(value);
  }
  f13() {
    var value = this.v2d_1.f2l();
    if (!equalsLong(value, fromInt(convertToInt(value)))) {
      this.v2d_1.t2i("Failed to parse int for input '" + value.toString() + "'");
    }
    return convertToInt(value);
  }
  g13() {
    return this.v2d_1.f2l();
  }
  h13() {
    var tmp0 = this.v2d_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.j2k();
      try {
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.t2i("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.t2d_1.p2d_1.j2f_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.v2d_1, result);
  }
  i13() {
    var tmp0 = this.v2d_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.j2k();
      try {
        tmp$ret$0 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.t2i("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.t2d_1.p2d_1.j2f_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.v2d_1, result);
  }
  j13() {
    var string = this.v2d_1.j2k();
    if (!(string.length === 1)) {
      this.v2d_1.t2i("Expected single char, but got '" + string + "'");
    }
    return charCodeAt(string, 0);
  }
  k13() {
    var tmp;
    if (this.z2d_1.b2f_1) {
      tmp = this.v2d_1.x2k();
    } else {
      tmp = this.v2d_1.i2k();
    }
    return tmp;
  }
  m13(descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.v2d_1, this.t2d_1) : super.m13(descriptor);
  }
  l13(enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.t2d_1, this.k13(), ' at path ' + this.v2d_1.c2e_1.n2j());
  }
}
class JsonDecoderForUnsignedTypes extends AbstractDecoder {
  constructor(lexer, json) {
    super();
    this.g2l_1 = lexer;
    this.h2l_1 = json.l10();
  }
  l10() {
    return this.h2l_1;
  }
  f14(descriptor) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.o(toString(message));
  }
  f13() {
    var tmp0 = this.g2l_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.j2k();
      try {
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = toUInt(input);
        tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.t2i("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  g13() {
    var tmp0 = this.g2l_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.j2k();
      try {
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = toULong(input);
        tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.t2i("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  d13() {
    var tmp0 = this.g2l_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.j2k();
      try {
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = toUByte(input);
        tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.t2i("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  e13() {
    var tmp0 = this.g2l_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.j2k();
      try {
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = toUShort(input);
        tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.t2i("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
}
class StreamingJsonEncoder extends AbstractEncoder {
  constructor(composer, json, mode, modeReuseCache) {
    return new.target.i2l(composer, json, mode, modeReuseCache);
  }
  static i2l(composer, json, mode, modeReuseCache) {
    var $this = this.h14();
    $this.r2j_1 = composer;
    $this.s2j_1 = json;
    $this.t2j_1 = mode;
    $this.u2j_1 = modeReuseCache;
    $this.v2j_1 = $this.s2j_1.l10();
    $this.w2j_1 = $this.s2j_1.p2d_1;
    $this.x2j_1 = false;
    $this.y2j_1 = null;
    $this.z2j_1 = null;
    var i = $this.t2j_1.w1_1;
    if (!($this.u2j_1 == null)) {
      if (!($this.u2j_1[i] === null) || !($this.u2j_1[i] === $this)) {
        $this.u2j_1[i] = $this;
      }
    }
    return $this;
  }
  q2f() {
    return this.s2j_1;
  }
  static a2k(output, json, mode, modeReuseCache) {
    return this.i2l(Composer_0(output, json), json, mode, modeReuseCache);
  }
  l10() {
    return this.v2j_1;
  }
  m15(descriptor, index) {
    return this.w2j_1.z2e_1;
  }
  h15(serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.q2f().p2d_1.h2f_1) {
        serializer.ez(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.q2f().p2d_1.p2f_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.q2f().p2d_1.p2f_1.w1_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            var it = serializer.dz().w11();
            tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.dz(), this.q2f()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          if (value == null) {
            var message = 'Value for serializer ' + toString(serializer.dz()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException.h2(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          access$validateIfSealed$tPolymorphicKt(serializer, actual, baseClassDiscriminator);
          checkKind_0(actual.dz().w11());
        }
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        var serialName = actualSerializer.dz().g10();
        this.y2j_1 = baseClassDiscriminator;
        this.z2j_1 = serialName;
      }
      actualSerializer.ez(this, value);
    }
  }
  p13(descriptor) {
    var newMode = switchMode(this.s2j_1, descriptor);
    if (!(newMode.b2l_1 === _Char___init__impl__6a9atx(0))) {
      this.r2j_1.k2h(newMode.b2l_1);
      this.r2j_1.f2h();
    }
    var discriminator = this.y2j_1;
    if (!(discriminator == null)) {
      var tmp0_elvis_lhs = this.z2j_1;
      encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.g10() : tmp0_elvis_lhs);
      this.y2j_1 = null;
      this.z2j_1 = null;
    }
    if (this.t2j_1.equals(newMode)) {
      return this;
    }
    var tmp1_safe_receiver = this.u2j_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.w1_1];
    return tmp2_elvis_lhs == null ? StreamingJsonEncoder.i2l(this.r2j_1, this.s2j_1, newMode, this.u2j_1) : tmp2_elvis_lhs;
  }
  q13(descriptor) {
    if (!(this.t2j_1.c2l_1 === _Char___init__impl__6a9atx(0))) {
      this.r2j_1.g2h();
      this.r2j_1.i2h();
      this.r2j_1.k2h(this.t2j_1.c2l_1);
    }
  }
  i14(descriptor, index) {
    switch (this.t2j_1.w1_1) {
      case 1:
        if (!this.r2j_1.e2h_1) {
          this.r2j_1.k2h(_Char___init__impl__6a9atx(44));
        }

        this.r2j_1.h2h();
        break;
      case 2:
        if (!this.r2j_1.e2h_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.r2j_1.k2h(_Char___init__impl__6a9atx(44));
            this.r2j_1.h2h();
            tmp_0 = true;
          } else {
            this.r2j_1.k2h(_Char___init__impl__6a9atx(58));
            this.r2j_1.j2h();
            tmp_0 = false;
          }
          tmp.x2j_1 = tmp_0;
        } else {
          this.x2j_1 = true;
          this.r2j_1.h2h();
        }

        break;
      case 3:
        if (index === 0)
          this.x2j_1 = true;
        if (index === 1) {
          this.r2j_1.k2h(_Char___init__impl__6a9atx(44));
          this.r2j_1.j2h();
          this.x2j_1 = false;
        }

        break;
      default:
        if (!this.r2j_1.e2h_1) {
          this.r2j_1.k2h(_Char___init__impl__6a9atx(44));
        }

        this.r2j_1.h2h();
        this.t14(getJsonElementName(descriptor, this.s2j_1, index));
        this.r2j_1.k2h(_Char___init__impl__6a9atx(58));
        this.r2j_1.j2h();
        break;
    }
    return true;
  }
  i15(descriptor, index, serializer, value) {
    if (!(value == null) || this.w2j_1.e2f_1) {
      super.i15(descriptor, index, serializer, value);
    }
  }
  v14(descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.r2j_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.r2j_1;
      } else {
        var tmp0 = this.r2j_1.d2h_1;
        var p1 = this.x2j_1;
        tmp_0 = new ComposerForUnsignedNumbers(tmp0, p1);
      }
      var tmp$ret$0 = tmp_0;
      tmp = StreamingJsonEncoder.i2l(tmp$ret$0, this.s2j_1, this.t2j_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.r2j_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.r2j_1;
      } else {
        var tmp0_0 = this.r2j_1.d2h_1;
        var p1_0 = this.x2j_1;
        tmp_2 = new ComposerForUnquotedLiterals(tmp0_0, p1_0);
      }
      var tmp$ret$2 = tmp_2;
      tmp = StreamingJsonEncoder.i2l(tmp$ret$2, this.s2j_1, this.t2j_1, null);
    } else if (!(this.y2j_1 == null)) {
      // Inline function 'kotlin.apply' call
      this.z2j_1 = descriptor.g10();
      tmp = this;
    } else {
      tmp = super.v14(descriptor);
    }
    return tmp;
  }
  k14() {
    this.r2j_1.m2h('null');
  }
  l14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.v2h(value);
    }
  }
  m14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.q2h(value);
    }
  }
  n14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.s2h(value);
    }
  }
  o14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.t2h(value);
    }
  }
  p14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.u2h(value);
    }
  }
  q14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.o2h(value);
    }
    if (!this.w2j_1.j2f_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.r2j_1.d2h_1));
    }
  }
  r14(value) {
    if (this.x2j_1) {
      this.t14(value.toString());
    } else {
      this.r2j_1.p2h(value);
    }
    if (!this.w2j_1.j2f_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.r2j_1.d2h_1));
    }
  }
  s14(value) {
    this.t14(toString_1(value));
  }
  t14(value) {
    return this.r2j_1.w2h(value);
  }
  u14(enumDescriptor, index) {
    this.t14(enumDescriptor.a12(index));
  }
}
class AbstractJsonTreeDecoder extends NamedValueDecoder {
  constructor(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    super();
    this.l2l_1 = json;
    this.m2l_1 = value;
    this.n2l_1 = polymorphicDiscriminator;
    this.o2l_1 = this.q2f().p2d_1;
  }
  q2f() {
    return this.l2l_1;
  }
  k3() {
    return this.m2l_1;
  }
  l10() {
    return this.q2f().l10();
  }
  q2l() {
    var tmp0_safe_receiver = this.e1i();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.r2l(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.k3() : tmp1_elvis_lhs;
  }
  p2l(currentTag) {
    return this.g1i() + ('.' + currentTag);
  }
  r2f() {
    return this.q2l();
  }
  o13(deserializer) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.q2f().p2d_1.h2f_1;
      }
      if (tmp) {
        tmp$ret$0 = deserializer.fz(this);
        break $l$block;
      }
      var discriminator = classDiscriminator(deserializer.dz(), this.q2f());
      var tmp0 = this.r2f();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = deserializer.dz().g10();
      if (!(tmp0 instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).j1();
        var tmp_1 = getKClassFromExpression(tmp0).j1();
        var tmp$ret$2 = this.g1i();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp0));
      }
      var jsonTree = tmp0;
      var tmp0_safe_receiver = jsonTree.wi(discriminator);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
      var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
      var tmp_2;
      try {
        tmp_2 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_3;
        if ($p instanceof SerializationException) {
          var it = $p;
          throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
        } else {
          throw $p;
        }
      }
      var tmp_4 = tmp_2;
      var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
      tmp$ret$0 = readPolymorphicJson(this.q2f(), discriminator, jsonTree, actualSerializer);
    }
    return tmp$ret$0;
  }
  f1i(parentName, childName) {
    return childName;
  }
  p13(descriptor) {
    var currentObject = this.q2l();
    var tmp0_subject = descriptor.w11();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.q2f();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = descriptor.g10();
      if (!(currentObject instanceof JsonArray)) {
        var tmp_2 = getKClass(JsonArray).j1();
        var tmp_3 = getKClassFromExpression(currentObject).j1();
        var tmp$ret$2 = this.g1i();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(currentObject));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.q2f();
        var keyDescriptor = carrierDescriptor(descriptor.d12(0), this_0.l10());
        var keyKind = keyDescriptor.w11();
        var tmp_4;
        var tmp_5;
        if (keyKind instanceof PrimitiveKind) {
          tmp_5 = true;
        } else {
          tmp_5 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_5) {
          var tmp_6 = this.q2f();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_0 = descriptor.g10();
          if (!(currentObject instanceof JsonObject)) {
            var tmp_7 = getKClass(JsonObject).j1();
            var tmp_8 = getKClassFromExpression(currentObject).j1();
            var tmp$ret$7 = this.g1i();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$7, toString(currentObject));
          }
          tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
        } else {
          if (this_0.p2d_1.c2f_1) {
            var tmp_9 = this.q2f();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_1 = descriptor.g10();
            if (!(currentObject instanceof JsonArray)) {
              var tmp_10 = getKClass(JsonArray).j1();
              var tmp_11 = getKClassFromExpression(currentObject).j1();
              var tmp$ret$11 = this.g1i();
              throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$11, toString(currentObject));
            }
            tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_4;
      } else {
        var tmp_12 = this.q2f();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_2 = descriptor.g10();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_13 = getKClass(JsonObject).j1();
          var tmp_14 = getKClassFromExpression(currentObject).j1();
          var tmp$ret$14 = this.g1i();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$14, toString(currentObject));
        }
        tmp = new JsonTreeDecoder(tmp_12, currentObject, this.n2l_1);
      }
    }
    return tmp;
  }
  q13(descriptor) {
  }
  a13() {
    var tmp = this.q2l();
    return !(tmp instanceof JsonNull);
  }
  s2l(tag, enumDescriptor) {
    var tmp = this.q2f();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    var tmp2 = this.r2l(tag);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = enumDescriptor.g10();
    if (!(tmp2 instanceof JsonPrimitive)) {
      var tmp_0 = getKClass(JsonPrimitive).j1();
      var tmp_1 = getKClassFromExpression(tmp2).j1();
      var tmp$ret$3 = this.p2l(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$3, toString(tmp2));
    }
    return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.s2f());
  }
  s1i(tag, enumDescriptor) {
    return this.s2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  }
  t2l(tag) {
    return !(this.r2l(tag) === JsonNull_getInstance());
  }
  i1i(tag) {
    return this.t2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  u2l(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  j1i(tag) {
    return this.u2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  v2l(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-128, 127);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_1 = convertToByte(result);
        } else {
          tmp_1 = null;
        }
        var tmp0_elvis_lhs = tmp_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_2;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  k1i(tag) {
    return this.v2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  w2l(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-32768, 32767);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_1 = convertToShort(result);
        } else {
          tmp_1 = null;
        }
        var tmp0_elvis_lhs = tmp_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_2;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  l1i(tag) {
    return this.w2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  x2l(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-2147483648, 2147483647);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_1 = convertToInt(result);
        } else {
          tmp_1 = null;
        }
        var tmp0_elvis_lhs = tmp_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_2;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  m1i(tag) {
    return this.x2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  y2l(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = parseLongImpl(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  n1i(tag) {
    return this.y2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  z2l(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_float(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.q2f().p2d_1.j2f_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.q2l()));
  }
  o1i(tag) {
    return this.z2l((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  a2m(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_double(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.q2f().p2d_1.j2f_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.q2l()));
  }
  p1i(tag) {
    return this.a2m((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  b2m(tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.r2l(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).j1();
        var tmp_0 = getKClassFromExpression(value).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = new Char(single(literal.s2f()));
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1.f4_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  q1i(tag) {
    return this.b2m((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  c2m(tag) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.r2l(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).j1();
      var tmp_0 = getKClassFromExpression(value).j1();
      var tmp$ret$2 = this.p2l(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$2, toString(value));
    }
    var value_0 = value;
    if (!(value_0 instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.p2l(tag), toString(this.q2l()));
    if (!value_0.b2g_1 && !this.q2f().p2d_1.b2f_1) {
      throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.p2l(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.q2l()));
    }
    return value_0.d2g_1;
  }
  r1i(tag) {
    return this.c2m((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  d2m(tag, inlineDescriptor) {
    var tmp;
    if (get_isUnsignedNumber(inlineDescriptor)) {
      var tmp_0 = this.q2f();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      var tmp2 = this.r2l(tag);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = inlineDescriptor.g10();
      if (!(tmp2 instanceof JsonPrimitive)) {
        var tmp_1 = getKClass(JsonPrimitive).j1();
        var tmp_2 = getKClassFromExpression(tmp2).j1();
        var tmp$ret$3 = this.p2l(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$3, toString(tmp2));
      }
      var lexer = StringJsonLexer_0(tmp_0, tmp2.s2f());
      tmp = new JsonDecoderForUnsignedTypes(lexer, this.q2f());
    } else {
      tmp = super.t1i(tag, inlineDescriptor);
    }
    return tmp;
  }
  t1i(tag, inlineDescriptor) {
    return this.d2m((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  }
  m13(descriptor) {
    return !(this.e1i() == null) ? super.m13(descriptor) : (new JsonPrimitiveDecoder(this.q2f(), this.k3(), this.n2l_1)).m13(descriptor);
  }
}
class JsonTreeDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value, polymorphicDiscriminator, polyDescriptor) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    super(json, value, polymorphicDiscriminator);
    this.k2m_1 = value;
    this.l2m_1 = polyDescriptor;
    this.m2m_1 = 0;
    this.n2m_1 = false;
  }
  k3() {
    return this.k2m_1;
  }
  f14(descriptor) {
    $l$loop: while (this.m2m_1 < descriptor.y11()) {
      var _unary__edvuaz = this.m2m_1;
      this.m2m_1 = _unary__edvuaz + 1 | 0;
      var name = this.z1h(descriptor, _unary__edvuaz);
      var index = this.m2m_1 - 1 | 0;
      this.n2m_1 = false;
      var tmp;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.k3();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u4(name)) {
        tmp = true;
      } else {
        tmp = setForceNull(this, descriptor, index);
      }
      if (tmp) {
        if (!this.o2l_1.g2f_1)
          return index;
        var tmp0 = this.q2f();
        var tmp$ret$2;
        $l$block_2: {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
          var isOptional = descriptor.e12(index);
          var elementDescriptor = descriptor.d12(index);
          var tmp_0;
          if (isOptional && !elementDescriptor.p11()) {
            var tmp_1 = this.o2m(name);
            tmp_0 = tmp_1 instanceof JsonNull;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
          if (equals(elementDescriptor.w11(), ENUM_getInstance())) {
            var tmp_2;
            if (elementDescriptor.p11()) {
              var tmp_3 = this.o2m(name);
              tmp_2 = tmp_3 instanceof JsonNull;
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$2 = false;
              break $l$block_2;
            }
            var tmp_4 = this.o2m(name);
            var tmp0_safe_receiver = tmp_4 instanceof JsonPrimitive ? tmp_4 : null;
            var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
            var tmp_5;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$2 = false;
              break $l$block_2;
            } else {
              tmp_5 = tmp0_elvis_lhs;
            }
            var enumValue = tmp_5;
            var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
            var coerceToNull = !tmp0.p2d_1.e2f_1 && elementDescriptor.p11();
            if (enumIndex === -3 && (isOptional || coerceToNull)) {
              if (setForceNull(this, descriptor, index))
                return index;
              tmp$ret$2 = true;
              break $l$block_2;
            }
          }
          tmp$ret$2 = false;
        }
        if (tmp$ret$2)
          continue $l$loop;
        return index;
      }
    }
    return -1;
  }
  a13() {
    return !this.n2m_1 && super.a13();
  }
  a1i(descriptor, index) {
    var strategy = namingStrategy(descriptor, this.q2f());
    var baseName = descriptor.a12(index);
    if (strategy == null) {
      if (!this.o2l_1.k2f_1)
        return baseName;
      if (this.k3().x4().w2(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.q2f(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.k3().x4();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (deserializationNamesMap_0.w4(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.e2j(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  }
  r2l(tag) {
    return getValue(this.k3(), tag);
  }
  o2m(tag) {
    return this.k3().wi(tag);
  }
  p13(descriptor) {
    if (descriptor === this.l2m_1) {
      var tmp = this.q2f();
      var tmp2 = this.q2l();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = this.l2m_1.g10();
      if (!(tmp2 instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).j1();
        var tmp_1 = getKClassFromExpression(tmp2).j1();
        var tmp$ret$2 = this.g1i();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp2));
      }
      return new JsonTreeDecoder(tmp, tmp2, this.n2l_1, this.l2m_1);
    }
    return super.p13(descriptor);
  }
  q13(descriptor) {
    var tmp;
    if (ignoreUnknownKeys(descriptor, this.q2f())) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.w11();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.q2f());
    var tmp_1;
    if (strategy == null && !this.o2l_1.k2f_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.q2f(), descriptor).x4();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      var tmp0_safe_receiver = get_schemaCache(this.q2f()).o2k(descriptor, get_JsonDeserializationNamesKey());
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x4();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var _iterator__ex2g4s = this.k3().x4().p1();
    while (_iterator__ex2g4s.q1()) {
      var key = _iterator__ex2g4s.r1();
      if (!names.w2(key) && !(key === this.n2l_1)) {
        throw JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "' at element: " + this.g1i() + '\n' + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.k3().toString()))));
      }
    }
  }
}
class JsonTreeListDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value) {
    super(json, value);
    this.v2m_1 = value;
    this.w2m_1 = this.v2m_1.s2();
    this.x2m_1 = -1;
  }
  k3() {
    return this.v2m_1;
  }
  a1i(descriptor, index) {
    return index.toString();
  }
  r2l(tag) {
    return this.v2m_1.u2(toInt(tag));
  }
  f14(descriptor) {
    while (this.x2m_1 < (this.w2m_1 - 1 | 0)) {
      this.x2m_1 = this.x2m_1 + 1 | 0;
      return this.x2m_1;
    }
    return -1;
  }
}
class JsonPrimitiveDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    super(json, value, polymorphicDiscriminator);
    this.e2n_1 = value;
    this.u1i('primitive');
  }
  k3() {
    return this.e2n_1;
  }
  f14(descriptor) {
    return 0;
  }
  r2l(tag) {
    // Inline function 'kotlin.require' call
    if (!(tag === 'primitive')) {
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException.h2(toString(message));
    }
    return this.e2n_1;
  }
}
class JsonTreeMapDecoder extends JsonTreeDecoder {
  constructor(json, value) {
    super(json, value);
    this.p2n_1 = value;
    this.q2n_1 = toList(this.p2n_1.x4());
    this.r2n_1 = imul(this.q2n_1.s2(), 2);
    this.s2n_1 = -1;
  }
  k3() {
    return this.p2n_1;
  }
  a1i(descriptor, index) {
    var i = index / 2 | 0;
    return this.q2n_1.u2(i);
  }
  f14(descriptor) {
    while (this.s2n_1 < (this.r2n_1 - 1 | 0)) {
      this.s2n_1 = this.s2n_1 + 1 | 0;
      return this.s2n_1;
    }
    return -1;
  }
  r2l(tag) {
    return (this.s2n_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.p2n_1, tag);
  }
  q13(descriptor) {
  }
}
class WriteMode extends Enum {
  constructor(name, ordinal, begin, end) {
    super(name, ordinal);
    this.b2l_1 = begin;
    this.c2l_1 = end;
  }
}
class AbstractJsonLexer {
  constructor() {
    this.b2e_1 = 0;
    this.c2e_1 = new JsonPath();
    this.d2e_1 = null;
    this.e2e_1 = StringBuilder.l1();
  }
  w2n() {
  }
  r2k() {
    var current = this.x2n();
    var source = this.u2n();
    if (current >= charSequenceLength(source) || current === -1)
      return false;
    if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
      this.b2e_1 = this.b2e_1 + 1 | 0;
      return true;
    }
    return false;
  }
  y2n(c) {
    return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
  }
  f2e() {
    var nextToken = this.l2k();
    if (!(nextToken === 10)) {
      this.t2i('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.u2n(), this.b2e_1 - 1 | 0)) + ' instead');
    }
  }
  f2k(expected) {
    var token = this.l2k();
    if (!(token === expected)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected_0 = tokenDescription(expected);
      var position = true ? this.b2e_1 - 1 | 0 : this.b2e_1;
      var s = this.b2e_1 === charSequenceLength(this.u2n()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.u2n(), position));
      var tmp$ret$1 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
      this.t2i(tmp$ret$1, position);
    }
    return token;
  }
  z2n(expected) {
    if (this.b2e_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.b2e_1;
        try {
          this.b2e_1 = this.b2e_1 - 1 | 0;
          tmp$ret$0 = this.j2k();
          break $l$block;
        }finally {
          this.b2e_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$0;
      if (inputLiteral === 'null') {
        this.s2i("Expected string literal but 'null' literal was found", this.b2e_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expectedToken = charToTokenClass(expected);
    var expected_0 = tokenDescription(expectedToken);
    var position = true ? this.b2e_1 - 1 | 0 : this.b2e_1;
    var s = this.b2e_1 === charSequenceLength(this.u2n()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.u2n(), position));
    var tmp$ret$3 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
    this.t2i(tmp$ret$3, position);
  }
  g2k() {
    var source = this.u2n();
    var cpos = this.b2e_1;
    $l$loop_0: while (true) {
      cpos = this.v2n(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.b2e_1 = cpos;
      return charToTokenClass(ch);
    }
    this.b2e_1 = cpos;
    return 10;
  }
  s2k(doConsume) {
    var current = this.x2n();
    current = this.v2n(current);
    var len = charSequenceLength(this.u2n()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charCodeAt('null', i) === charSequenceGet(this.u2n(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.u2n(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.b2e_1 = current + 4 | 0;
    }
    return true;
  }
  d2l(doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.s2k(doConsume) : $super.s2k.call(this, doConsume);
  }
  t2k(isLenient) {
    var token = this.g2k();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.j2k();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.i2k();
    }
    var string = tmp;
    this.d2e_1 = string;
    return string;
  }
  a2o() {
    this.d2e_1 = null;
  }
  qh(startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.u2n();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  }
  i2k() {
    if (!(this.d2e_1 == null)) {
      return takePeeked(this);
    }
    return this.w2k();
  }
  consumeString2(source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.v2n(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.t2i('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.t2n(lastPosition, currentPosition);
          currentPosition = this.v2n(currentPosition);
          if (currentPosition === -1) {
            this.t2i('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.qh(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.b2e_1 = currentPosition + 1 | 0;
    return string;
  }
  x2k() {
    var result = this.j2k();
    if (result === 'null' && wasUnquotedString(this)) {
      this.t2i("Unexpected 'null' value instead of string literal");
    }
    return result;
  }
  j2k() {
    if (!(this.d2e_1 == null)) {
      return takePeeked(this);
    }
    var current = this.x2n();
    if (current >= charSequenceLength(this.u2n()) || current === -1) {
      this.t2i('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.u2n(), current));
    if (token === 1) {
      return this.i2k();
    }
    if (!(token === 0)) {
      this.t2i('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.u2n(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.u2n(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.u2n())) {
        usedAppend = true;
        this.t2n(this.b2e_1, current);
        var eof = this.v2n(current);
        if (eof === -1) {
          this.b2e_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.qh(this.b2e_1, current);
    } else {
      tmp = decodedString(this, this.b2e_1, current);
    }
    var result = tmp;
    this.b2e_1 = current;
    return result;
  }
  t2n(fromIndex, toIndex) {
    this.e2e_1.hh(this.u2n(), fromIndex, toIndex);
  }
  v2k(allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList.p2();
    var lastToken = this.g2k();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.j2k();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.g2k();
      if (lastToken === 1) {
        if (allowLenientStrings)
          this.j2k();
        else
          this.w2k();
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 || tmp0_subject === 6) {
        tokenStack.d2(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.b2e_1, 'found ] instead of } at path: ' + this.c2e_1.toString(), this.u2n());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.b2e_1, 'found } instead of ] at path: ' + this.c2e_1.toString(), this.u2n());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.t2i('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.l2k();
      if (tokenStack.s2() === 0)
        return Unit_instance;
    }
  }
  toString() {
    return "JsonReader(source='" + toString(this.u2n()) + "', currentPosition=" + this.b2e_1 + ')';
  }
  u2k(key) {
    var processed = this.qh(0, this.b2e_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    throw JsonDecodingException.u2g("Encountered an unknown key '" + key + "' at offset " + lastIndexOf_0 + ' at path: ' + this.c2e_1.n2j() + "\nUse 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.u2n(), lastIndexOf_0))));
  }
  s2i(message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.c2e_1.n2j() + hintMessage, this.u2n());
  }
  t2i(message, position, hint, $super) {
    position = position === VOID ? this.b2e_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.s2i(message, position, hint) : $super.s2i.call(this, message, position, hint);
  }
  f2l() {
    var current = this.x2n();
    current = this.v2n(current);
    if (current >= charSequenceLength(this.u2n()) || current === -1) {
      this.t2i('EOF');
    }
    var tmp;
    if (charSequenceGet(this.u2n(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.u2n())) {
        this.t2i('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.u2n()))) {
      var ch = charSequenceGet(this.u2n(), current);
      if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
        if (current === start) {
          this.t2i('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
        if (current === start) {
          this.t2i("Unexpected symbol '-' in numeric literal");
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
        if (current === start) {
          this.t2i("Unexpected symbol '+' in numeric literal");
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.t2i("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.t2i("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.times' call
        var this_0 = exponentAccumulator;
        // Inline function 'kotlin.Long.plus' call
        var this_1 = multiply(this_0, fromInt(10));
        exponentAccumulator = add(this_1, fromInt(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.times' call
      var this_2 = accumulator;
      // Inline function 'kotlin.Long.minus' call
      var this_3 = multiply(this_2, fromInt(10));
      accumulator = subtract(this_3, fromInt(digit));
      if (compare(accumulator, new Long(0, 0)) > 0) {
        this.t2i('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.t2i('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.t2i('EOF');
      }
      if (!(charSequenceGet(this.u2n(), current) === _Char___init__impl__6a9atx(34))) {
        this.t2i('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.b2e_1 = current;
    if (hasExponent) {
      var doubleAccumulator = toNumber(accumulator) * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      if (doubleAccumulator > toNumber(new Long(-1, 2147483647)) || doubleAccumulator < toNumber(new Long(0, -2147483648))) {
        this.t2i('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.t2i("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!equalsLong(accumulator, new Long(0, -2147483648))) {
      tmp_0 = negate(accumulator);
    } else {
      this.t2i('Numeric value overflow');
    }
    return tmp_0;
  }
  e2g() {
    var result = this.f2l();
    var next = this.l2k();
    if (!(next === 10)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected = tokenDescription(10);
      var position = true ? this.b2e_1 - 1 | 0 : this.b2e_1;
      var s = this.b2e_1 === charSequenceLength(this.u2n()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.u2n(), position));
      var tmp$ret$1 = "Expected input to contain a single valid number, but got '" + s + "' after it";
      this.t2i(tmp$ret$1, position);
    }
    return result;
  }
  e2l() {
    var current = this.x2n();
    if (current === charSequenceLength(this.u2n())) {
      this.t2i('EOF');
    }
    var tmp;
    if (charSequenceGet(this.u2n(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.b2e_1 === charSequenceLength(this.u2n())) {
        this.t2i('EOF');
      }
      if (!(charSequenceGet(this.u2n(), this.b2e_1) === _Char___init__impl__6a9atx(34))) {
        this.t2i('Expected closing quotation mark');
      }
      this.b2e_1 = this.b2e_1 + 1 | 0;
    }
    return result;
  }
}
class CharMappings {
  constructor() {
    CharMappings_instance = this;
    this.b2o_1 = charArray(117);
    this.c2o_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
}
class StringJsonLexer extends AbstractJsonLexer {
  constructor(source) {
    super();
    this.m2o_1 = source;
  }
  u2n() {
    return this.m2o_1;
  }
  v2n(position) {
    return position < this.u2n().length ? position : -1;
  }
  l2k() {
    var source = this.u2n();
    var cpos = this.b2e_1;
    $l$loop: while (!(cpos === -1) && cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charCodeAt(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.b2e_1 = cpos;
      return charToTokenClass(c);
    }
    this.b2e_1 = source.length;
    return 10;
  }
  h2k() {
    var current = this.b2e_1;
    if (current === -1)
      return false;
    var source = this.u2n();
    $l$loop: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.b2e_1 = current;
      return this.y2n(c);
    }
    this.b2e_1 = current;
    return false;
  }
  x2n() {
    var current = this.b2e_1;
    if (current === -1)
      return current;
    var source = this.u2n();
    $l$loop: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.b2e_1 = current;
    return current;
  }
  q2k(expected) {
    if (this.b2e_1 === -1) {
      this.z2n(expected);
    }
    var source = this.u2n();
    var cpos = this.b2e_1;
    $l$loop: while (cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charCodeAt(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.b2e_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.z2n(expected);
    }
    this.b2e_1 = -1;
    this.z2n(expected);
  }
  w2k() {
    this.q2k(_Char___init__impl__6a9atx(34));
    var current = this.b2e_1;
    var closingQuote = indexOf_0(this.u2n(), _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.j2k();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected = tokenDescription(1);
      var position = false ? this.b2e_1 - 1 | 0 : this.b2e_1;
      var s = this.b2e_1 === charSequenceLength(this.u2n()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.u2n(), position));
      var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
      this.t2i(tmp$ret$1, position);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(this.u2n(), i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.u2n(), this.b2e_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.b2e_1 = closingQuote + 1 | 0;
    return substring(this.u2n(), current, closingQuote);
  }
  y2k(keyToMatch, isLenient) {
    var positionSnapshot = this.b2e_1;
    try {
      if (!(this.l2k() === 6))
        return null;
      var firstKey = this.t2k(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.a2o();
      if (!(this.l2k() === 5))
        return null;
      return this.t2k(isLenient);
    }finally {
      this.b2e_1 = positionSnapshot;
      this.a2o();
    }
  }
}
class StringJsonLexerWithComments extends StringJsonLexer {
  l2k() {
    var source = this.u2n();
    var cpos = this.x2n();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.b2e_1 = cpos + 1 | 0;
    return charToTokenClass(charCodeAt(source, cpos));
  }
  h2k() {
    var current = this.x2n();
    if (current >= this.u2n().length || current === -1)
      return false;
    return this.y2n(charCodeAt(this.u2n(), current));
  }
  q2k(expected) {
    var source = this.u2n();
    var current = this.x2n();
    if (current >= source.length || current === -1) {
      this.b2e_1 = -1;
      this.z2n(expected);
    }
    var c = charCodeAt(source, current);
    this.b2e_1 = current + 1 | 0;
    if (c === expected)
      return Unit_instance;
    else {
      this.z2n(expected);
    }
  }
  g2k() {
    var source = this.u2n();
    var cpos = this.x2n();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.b2e_1 = cpos;
    return charToTokenClass(charCodeAt(source, cpos));
  }
  x2n() {
    var current = this.b2e_1;
    if (current === -1)
      return current;
    var source = this.u2n();
    $l$loop_1: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop_1;
      }
      if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
        var tmp0_subject = charCodeAt(source, current + 1 | 0);
        if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
          current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
          if (current === -1) {
            current = source.length;
          } else {
            current = current + 1 | 0;
          }
          continue $l$loop_1;
        } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
          current = indexOf(source, '*/', current + 2 | 0);
          if (current === -1) {
            this.b2e_1 = source.length;
            this.t2i('Expected end of the block comment: "*/", but had EOF instead');
          } else {
            current = current + 2 | 0;
          }
          continue $l$loop_1;
        }
      }
      break $l$loop_1;
    }
    this.b2e_1 = current;
    return current;
  }
}
class JsonToStringWriter {
  constructor() {
    this.s2d_1 = StringBuilder.ad(128);
  }
  r2h(value) {
    this.s2d_1.lh(value);
  }
  l2h(char) {
    this.s2d_1.o1(char);
  }
  n2h(text) {
    this.s2d_1.m1(text);
  }
  x2h(text) {
    printQuoted(this.s2d_1, text);
  }
  a2b() {
    this.s2d_1.sh();
  }
  toString() {
    return this.s2d_1.toString();
  }
}
//endregion
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new Default();
  return Default_instance;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new JsonBuilder(from);
  builderAction(builder);
  var conf = builder.y2e();
  return new JsonImpl(conf, builder.x2e_1);
}
function validateConfiguration($this) {
  if (equals($this.l10(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new JsonSerializersModuleValidator($this.p2d_1);
  $this.l10().f1k(collector);
}
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
var Companion_instance;
function Companion_getInstance_3() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.j3();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.k3();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.l1();
  printQuoted(this_0, k);
  this_0.o1(_Char___init__impl__6a9atx(58));
  this_0.s1(v);
  return this_0.toString();
}
var Companion_instance_2;
function Companion_getInstance_6() {
  return Companion_instance_2;
}
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new JsonNull();
  return JsonNull_instance;
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull_0(_this__u8e3s4.s2f());
}
function parseLongImpl(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return (new StringJsonLexer(_this__u8e3s4.s2f())).e2g();
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.s2f();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.s2f());
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.s2f();
  }
  return tmp;
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, true);
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException.h2('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.oz('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.oz('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.oz('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.oz('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.oz('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().f2g_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().g2g_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().h2g_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().i2g_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().j2g_1;
}
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance === VOID)
    new JsonElementSerializer();
  return JsonElementSerializer_instance;
}
function defer(deferred) {
  return new defer$1(deferred);
}
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance === VOID)
    new JsonPrimitiveSerializer();
  return JsonPrimitiveSerializer_instance;
}
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance === VOID)
    new JsonNullSerializer();
  return JsonNullSerializer_instance;
}
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance === VOID)
    new JsonLiteralSerializer();
  return JsonLiteralSerializer_instance;
}
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance === VOID)
    new JsonObjectDescriptor();
  return JsonObjectDescriptor_instance;
}
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance === VOID)
    new JsonObjectSerializer();
  return JsonObjectSerializer_instance;
}
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance === VOID)
    new JsonArrayDescriptor();
  return JsonArrayDescriptor_instance;
}
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance === VOID)
    new JsonArraySerializer();
  return JsonArraySerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.o('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.o('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.c2h_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
  return tmp0.k3();
}
function defer$o$_get_original_$ref_3cje7k() {
  return constructCallableReference((p0) => _get_original__l7ku1m(p0), 1, 0, 15);
}
function Composer_0(sb, json) {
  return json.p2d_1.d2f_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
}
function readIfAbsent($this, descriptor, index) {
  $this.j2i_1 = (!descriptor.e12(index) && descriptor.d12(index).p11());
  return $this.j2i_1;
}
function JsonElementMarker$readIfAbsent$ref(p0) {
  return constructCallableReference((p0_0, p1) => {
    var tmp0 = p0;
    return readIfAbsent(tmp0, p0_0, p1);
  }, 2, 0, 16, 'readIfAbsent', [p0]);
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
}
function JsonDecodingException_1(offset, message) {
  return JsonDecodingException.u2g(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  var tmp2 = coerceAtLeast(start_0, 0);
  // Inline function 'kotlin.text.substring' call
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
}
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.s2i('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.b2e_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingComma = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.t2i('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
function InvalidFloatingPointEncoded(value, output) {
  return JsonEncodingException.a2j('Unexpected special floating-point value ' + toString(value) + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function InvalidKeyKindException(keyDescriptor) {
  return JsonEncodingException.a2j("Value of type '" + keyDescriptor.g10() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.w11().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
}
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function ignoreUnknownKeys(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp;
  if (json.p2d_1.a2f_1) {
    tmp = true;
  } else {
    var tmp0 = _this__u8e3s4.z11();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.n1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof JsonIgnoreUnknownKeys) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$0);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.b12(name);
  if (!(index === -3))
    return index;
  if (!json.p2d_1.k2f_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
  suffix = suffix === VOID ? '' : suffix;
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var index = getJsonNameIndex(_this__u8e3s4, json, name);
  if (index === -3)
    throw SerializationException.y10(_this__u8e3s4.g10() + " does not contain element with name '" + name + "'" + suffix);
  return index;
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.a12(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.w11(), CLASS_getInstance()) ? json.p2d_1.l2f_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.c2j(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.p2d_1.m2f_1 && equals(descriptor.w11(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).w4(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.c2j(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap.m7();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.y11();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = _this__u8e3s4.c12(i);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof JsonNames) {
          destination.d2(element);
        }
      }
      var tmp0_safe_receiver = singleOrNull(destination);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2j_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.a12(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.e2j(_this__u8e3s4, i, _this__u8e3s4.a12(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (builder.n1()) {
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
  return () => buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
}
function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
  return () => {
    var tmp = 0;
    var tmp_0 = $this_serializationNamesIndices.y11();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = $this_serializationNamesIndices.a12(tmp_2);
      tmp_1[tmp_2] = $strategy.e2j($this_serializationNamesIndices, tmp_2, baseName);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.w11(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).u4(name)) {
    throw JsonException.r2i("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.a12(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.a12(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.b5(name, index);
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new Key();
    JsonSerializationNamesKey = new Key();
  }
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
function resize($this) {
  var newSize = imul($this.h2j_1, 2);
  $this.f2j_1 = copyOf($this.f2j_1, newSize);
  var tmp = 0;
  var tmp_0 = new Int32Array(newSize);
  while (tmp < newSize) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var newIndices = tmp_0;
  // Inline function 'kotlin.collections.copyInto' call
  var this_0 = $this.g2j_1;
  var endIndex = this_0.length;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = this_0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp_1, newIndices, 0, 0, endIndex);
  $this.g2j_1 = newIndices;
}
function checkKind($this, descriptor, actualClass) {
  var kind = descriptor.w11();
  var tmp;
  if (kind instanceof PolymorphicKind) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException.h2('Serializer for ' + actualClass.j1() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.p2j_1)
    return Unit_instance;
  if (!$this.q2j_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind;
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM;
  }
  if (tmp_0) {
    throw IllegalArgumentException.h2('Serializer for ' + actualClass.j1() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
function checkDiscriminatorCollisions($this, descriptor, actualClass) {
  var inductionVariable = 0;
  var last = descriptor.y11();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var name = descriptor.a12(i);
      if (name === $this.o2j_1) {
        throw IllegalArgumentException.h2('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, rename property with @SerialName annotation or fall back to array polymorphism');
      }
    }
     while (inductionVariable < last);
}
function encodeByWriter(json, writer, serializer, value) {
  var tmp = WriteMode_OBJ_getInstance();
  // Inline function 'kotlin.arrayOfNulls' call
  var size = get_entries().s2();
  var tmp$ret$0 = Array(size);
  var encoder = StreamingJsonEncoder.a2k(writer, json, tmp, tmp$ret$0);
  encoder.h15(serializer, value);
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.b2k_1.f2k(6);
  if ($this.b2k_1.g2k() === 4) {
    $this.b2k_1.t2i('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap.m7();
  $l$loop: while ($this.b2k_1.h2k()) {
    var key = $this.c2k_1 ? $this.b2k_1.j2k() : $this.b2k_1.i2k();
    $this.b2k_1.f2k(5);
    var element = $this.k2k();
    // Inline function 'kotlin.collections.set' call
    result.b5(key, element);
    lastToken = $this.b2k_1.l2k();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.b2k_1.t2i('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.b2k_1.f2k(7);
  } else if (lastToken === 4) {
    if (!$this.d2k_1) {
      invalidTrailingComma($this.b2k_1);
    }
    $this.b2k_1.f2k(7);
  }
  return new JsonObject(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.b2k_1.f2k(6);
  if ($this.b2k_1.g2k() === 4) {
    $this.b2k_1.t2i('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap.m7();
  $l$loop: while ($this.b2k_1.h2k()) {
    var key = $this.c2k_1 ? $this.b2k_1.j2k() : $this.b2k_1.i2k();
    $this.b2k_1.f2k(5);
    var element = yield* $receiver.ow(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.b5(key, element);
    lastToken = $this.b2k_1.l2k();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.b2k_1.t2i('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.b2k_1.f2k(7);
  } else if (lastToken === 4) {
    if (!$this.d2k_1) {
      invalidTrailingComma($this.b2k_1);
    }
    $this.b2k_1.f2k(7);
  }
  return new JsonObject(result);
}
function readArray($this) {
  var lastToken = $this.b2k_1.l2k();
  if ($this.b2k_1.g2k() === 4) {
    $this.b2k_1.t2i('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList.p2();
  while ($this.b2k_1.h2k()) {
    var element = $this.k2k();
    result.d2(element);
    lastToken = $this.b2k_1.l2k();
    if (!(lastToken === 4)) {
      var tmp0 = $this.b2k_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.b2e_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.t2i(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.b2k_1.f2k(9);
  } else if (lastToken === 4) {
    if (!$this.d2k_1) {
      invalidTrailingComma($this.b2k_1, 'array');
    }
    $this.b2k_1.f2k(9);
  }
  return new JsonArray(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.c2k_1 || !isString) {
    tmp = $this.b2k_1.j2k();
  } else {
    tmp = $this.b2k_1.i2k();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new JsonLiteral(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0) {
  return constructCallableReference(function *($this$DeepRecursiveFunction, it, $completion) {
    var tmp0_subject = this$0.b2k_1.g2k();
    var tmp;
    if (tmp0_subject === 1) {
      tmp = readValue(this$0, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this$0, false);
    } else if (tmp0_subject === 6) {
      tmp = yield* /*#__NOINLINE__*/readObject_0(this$0, $this$DeepRecursiveFunction, $completion);
    } else if (tmp0_subject === 8) {
      tmp = readArray(this$0);
    } else {
      this$0.b2k_1.t2i("Can't begin reading element, unexpected token");
    }
    return tmp;
  }, 2);
}
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.z11().p1();
  while (_iterator__ex2g4s.q1()) {
    var annotation = _iterator__ex2g4s.r1();
    if (annotation instanceof JsonClassDiscriminator)
      return annotation.m2k_1;
  }
  return json.p2d_1.i2f_1;
}
function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
  if (!(serializer instanceof SealedClassSerializer))
    return Unit_instance;
  if (jsonCachedSerialNames(actualSerializer.dz()).w2(classDiscriminator)) {
    var baseName = serializer.dz().g10();
    var actualName = actualSerializer.dz().g10();
    // Inline function 'kotlin.error' call
    var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, rename property with @SerialName annotation or fall back to array polymorphism';
    throw IllegalStateException.o(toString(message));
  }
}
function checkKind_0(kind) {
  if (kind instanceof ENUM) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException.o(toString(message));
  }
  if (kind instanceof PrimitiveKind) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException.o(toString(message_0));
  }
  if (kind instanceof PolymorphicKind) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException.o(toString(message_1));
  }
}
function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
  return validateIfSealed(serializer, actualSerializer, classDiscriminator);
}
function trySkip($this, $receiver, unknownKey) {
  if ($receiver == null)
    return false;
  if ($receiver.p2k_1 === unknownKey) {
    $receiver.p2k_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.f14(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.v2d_1.g2k() === 4) {
    $this.v2d_1.t2i('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.x2d_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.x2d_1 === -1)) {
      hasComma = $this.v2d_1.r2k();
    }
  } else {
    $this.v2d_1.q2k(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.v2d_1.h2k()) {
    if (decodingKey) {
      if ($this.x2d_1 === -1) {
        var tmp0 = $this.v2d_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.b2e_1;
        if (!condition) {
          var tmp$ret$1 = 'Unexpected leading comma';
          tmp0.t2i(tmp$ret$1, position);
        }
      } else {
        var tmp0_0 = $this.v2d_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.b2e_1;
        if (!condition_0) {
          var tmp$ret$3 = 'Expected comma after the key-value pair';
          tmp0_0.t2i(tmp$ret$3, position_0);
        }
      }
    }
    $this.x2d_1 = $this.x2d_1 + 1 | 0;
    tmp = $this.x2d_1;
  } else {
    if (hasComma && !$this.t2d_1.p2d_1.n2f_1) {
      invalidTrailingComma($this.v2d_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.t2d_1;
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.e12(index);
    var elementDescriptor = descriptor.d12(index);
    var tmp;
    if (isOptional && !elementDescriptor.p11()) {
      tmp = $this.v2d_1.s2k(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.w11(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.p11()) {
        tmp_0 = $this.v2d_1.s2k(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.v2d_1.t2k($this.z2d_1.b2f_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.p2d_1.e2f_1 && elementDescriptor.p11();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.v2d_1.i2k();
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.v2d_1.r2k();
  while ($this.v2d_1.h2k()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.v2d_1.q2k(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.t2d_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.z2d_1.g2f_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.v2d_1.r2k();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.a2e_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.k2i(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.t2d_1.p2d_1.n2f_1) {
    invalidTrailingComma($this.v2d_1);
  }
  var tmp1_safe_receiver = $this.a2e_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l2i();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.t2d_1) || trySkip($this, $this.y2d_1, key)) {
    $this.v2d_1.v2k($this.z2d_1.b2f_1);
  } else {
    $this.v2d_1.c2e_1.m2j();
    $this.v2d_1.u2k(key);
  }
  return $this.v2d_1.r2k();
}
function decodeListIndex($this) {
  var hasComma = $this.v2d_1.r2k();
  var tmp;
  if ($this.v2d_1.h2k()) {
    if (!($this.x2d_1 === -1) && !hasComma) {
      $this.v2d_1.t2i('Expected end of the array or comma');
    }
    $this.x2d_1 = $this.x2d_1 + 1 | 0;
    tmp = $this.x2d_1;
  } else {
    if (hasComma && !$this.t2d_1.p2d_1.n2f_1) {
      invalidTrailingComma($this.v2d_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.z2d_1.b2f_1) {
    tmp = $this.v2d_1.x2k();
  } else {
    tmp = $this.v2d_1.w2k();
  }
  return tmp;
}
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.r2j_1.h2h();
  $this.t14(discriminator);
  $this.r2j_1.k2h(_Char___init__impl__6a9atx(58));
  $this.r2j_1.j2h();
  $this.t14(serialName);
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.x11() && get_unsignedNumberDescriptors().w2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.x11() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).dz(), serializer_0(Companion_getInstance()).dz(), serializer_2(Companion_getInstance_1()).dz(), serializer_3(Companion_getInstance_2()).dz()]);
  }
}
function get_ESCAPE_STRINGS() {
  _init_properties_StringOps_kt__fcy1db();
  return ESCAPE_STRINGS;
}
var ESCAPE_STRINGS;
var ESCAPE_MARKERS;
function toHexChar(i) {
  _init_properties_StringOps_kt__fcy1db();
  var d = i & 15;
  var tmp;
  if (d < 10) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp = numberToChar(d + tmp$ret$0 | 0);
  } else {
    var tmp_0 = d - 10 | 0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
  }
  return tmp;
}
function printQuoted(_this__u8e3s4, value) {
  _init_properties_StringOps_kt__fcy1db();
  _this__u8e3s4.o1(_Char___init__impl__6a9atx(34));
  var lastPos = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(value) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt(value, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
        _this__u8e3s4.hh(value, lastPos, i);
        _this__u8e3s4.m1(get_ESCAPE_STRINGS()[c]);
        lastPos = i + 1 | 0;
      }
    }
     while (inductionVariable <= last);
  if (!(lastPos === 0))
    _this__u8e3s4.hh(value, lastPos, value.length);
  else
    _this__u8e3s4.m1(value);
  _this__u8e3s4.o1(_Char___init__impl__6a9atx(34));
}
function toBooleanStrictOrNull_0(_this__u8e3s4) {
  _init_properties_StringOps_kt__fcy1db();
  return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
}
var properties_initialized_StringOps_kt_wzaea7;
function _init_properties_StringOps_kt__fcy1db() {
  if (!properties_initialized_StringOps_kt_wzaea7) {
    properties_initialized_StringOps_kt_wzaea7 = true;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.apply' call
    var this_0 = Array(93);
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = toHexChar(c >> 12);
        var c2 = toHexChar(c >> 8);
        var c3 = toHexChar(c >> 4);
        var c4 = toHexChar(c);
        this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
      }
       while (inductionVariable <= 31);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(34);
    this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(92);
    this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(9);
    this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(8);
    this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(13);
    this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
    this_0[12] = '\\f';
    ESCAPE_STRINGS = this_0;
    // Inline function 'kotlin.apply' call
    var this_7 = new Int8Array(93);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 <= 31)
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_7[c_0] = 1;
      }
       while (inductionVariable_0 <= 31);
    // Inline function 'kotlin.code' call
    var this_8 = _Char___init__impl__6a9atx(34);
    var tmp = Char__toInt_impl_vasixd(this_8);
    // Inline function 'kotlin.code' call
    var this_9 = _Char___init__impl__6a9atx(34);
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_9);
    this_7[tmp] = toByte(tmp$ret$3);
    // Inline function 'kotlin.code' call
    var this_10 = _Char___init__impl__6a9atx(92);
    var tmp_0 = Char__toInt_impl_vasixd(this_10);
    // Inline function 'kotlin.code' call
    var this_11 = _Char___init__impl__6a9atx(92);
    var tmp$ret$5 = Char__toInt_impl_vasixd(this_11);
    this_7[tmp_0] = toByte(tmp$ret$5);
    // Inline function 'kotlin.code' call
    var this_12 = _Char___init__impl__6a9atx(9);
    var tmp_1 = Char__toInt_impl_vasixd(this_12);
    // Inline function 'kotlin.code' call
    var this_13 = _Char___init__impl__6a9atx(116);
    var tmp$ret$7 = Char__toInt_impl_vasixd(this_13);
    this_7[tmp_1] = toByte(tmp$ret$7);
    // Inline function 'kotlin.code' call
    var this_14 = _Char___init__impl__6a9atx(8);
    var tmp_2 = Char__toInt_impl_vasixd(this_14);
    // Inline function 'kotlin.code' call
    var this_15 = _Char___init__impl__6a9atx(98);
    var tmp$ret$9 = Char__toInt_impl_vasixd(this_15);
    this_7[tmp_2] = toByte(tmp$ret$9);
    // Inline function 'kotlin.code' call
    var this_16 = _Char___init__impl__6a9atx(10);
    var tmp_3 = Char__toInt_impl_vasixd(this_16);
    // Inline function 'kotlin.code' call
    var this_17 = _Char___init__impl__6a9atx(110);
    var tmp$ret$11 = Char__toInt_impl_vasixd(this_17);
    this_7[tmp_3] = toByte(tmp$ret$11);
    // Inline function 'kotlin.code' call
    var this_18 = _Char___init__impl__6a9atx(13);
    var tmp_4 = Char__toInt_impl_vasixd(this_18);
    // Inline function 'kotlin.code' call
    var this_19 = _Char___init__impl__6a9atx(114);
    var tmp$ret$13 = Char__toInt_impl_vasixd(this_19);
    this_7[tmp_4] = toByte(tmp$ret$13);
    // Inline function 'kotlin.code' call
    var this_20 = _Char___init__impl__6a9atx(102);
    var tmp$ret$14 = Char__toInt_impl_vasixd(this_20);
    this_7[12] = toByte(tmp$ret$14);
    ESCAPE_MARKERS = this_7;
  }
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.p2l(tag), toString($this.q2l()));
}
function setForceNull($this, descriptor, index) {
  $this.n2m_1 = (!$this.q2f().p2d_1.e2f_1 && !descriptor.e12(index) && descriptor.d12(index).p11());
  return $this.n2m_1;
}
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.dz())).o13(deserializer);
}
var WriteMode_OBJ_instance;
var WriteMode_LIST_instance;
var WriteMode_MAP_instance;
var WriteMode_POLY_OBJ_instance;
function values() {
  return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WriteMode_entriesInitialized;
function WriteMode_initEntries() {
  if (WriteMode_entriesInitialized)
    return Unit_instance;
  WriteMode_entriesInitialized = true;
  WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var $ENTRIES;
function switchMode(_this__u8e3s4, desc) {
  var tmp0_subject = desc.w11();
  var tmp;
  if (tmp0_subject instanceof PolymorphicKind) {
    tmp = WriteMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = WriteMode_LIST_getInstance();
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.d12(0), _this__u8e3s4.l10());
        var keyKind = keyDescriptor.w11();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          tmp_0 = WriteMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.p2d_1.c2f_1) {
            tmp_0 = WriteMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = WriteMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.w11(), CONTEXTUAL_getInstance())) {
    var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
    tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  } else if (_this__u8e3s4.x11()) {
    tmp = carrierDescriptor(_this__u8e3s4.d12(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function WriteMode_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_OBJ_instance;
}
function WriteMode_LIST_getInstance() {
  WriteMode_initEntries();
  return WriteMode_LIST_instance;
}
function WriteMode_MAP_getInstance() {
  WriteMode_initEntries();
  return WriteMode_MAP_instance;
}
function WriteMode_POLY_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_POLY_OBJ_instance;
}
function appendEscape($this, lastPosition, current) {
  $this.t2n(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.t2n(lastPosition, currentPosition);
  var result = $this.e2e_1.toString();
  $this.e2e_1.ph(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.d2e_1);
  $this.d2e_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.u2n(), $this.b2e_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.v2n(currentPosition);
  if (currentPosition === -1) {
    $this.t2i('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.u2n();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.u2n(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.t2i("Invalid escaped char '" + toString_1(currentChar) + "'");
  }
  $this.e2e_1.o1(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.b2e_1 = startPos;
    $this.w2n();
    if (($this.b2e_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.t2i('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.b2e_1);
  }
  $this.e2e_1.o1(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.t2i("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.v2n(start);
  if (current >= charSequenceLength($this.u2n()) || current === -1) {
    $this.t2i('EOF');
  }
  var tmp = $this.u2n();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.code' call
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.t2i("Expected valid boolean literal prefix, but had '" + $this.j2k() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.u2n()) - current | 0) < literalSuffix.length) {
    $this.t2i('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charCodeAt(literalSuffix, i);
      var actual = charSequenceGet($this.u2n(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.t2i("Expected valid boolean literal prefix, but had '" + $this.j2k() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.b2e_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().c2o_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().b2o_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.b2o_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.c2o_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance === VOID)
    new CharMappings();
  return CharMappings_instance;
}
function StringJsonLexer_0(json, source) {
  return !json.p2d_1.o2f_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
}
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.r2d_1;
}
function createMapForCache(initialCapacity) {
  return HashMap.ga(initialCapacity);
}
//region block: post-declaration
initMetadataForClass(Json, 'Json', VOID, VOID, [StringFormat]);
initMetadataForObject(Default, 'Default');
initMetadataForClass(JsonBuilder, 'JsonBuilder');
initMetadataForClass(JsonImpl, 'JsonImpl');
initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
initMetadataForClass(JsonIgnoreUnknownKeys, 'JsonIgnoreUnknownKeys');
initMetadataForClass(JsonNames, 'JsonNames');
initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode');
initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForCompanion(Companion);
initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, VOID, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
initMetadataForCompanion(Companion_1);
initMetadataForClass(JsonObject, 'JsonObject', VOID, VOID, [KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
initMetadataForCompanion(Companion_2);
initMetadataForClass(JsonArray, 'JsonArray', VOID, VOID, [KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
initMetadataForObject(JsonNull, 'JsonNull', VOID, VOID, [SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
initMetadataForClass(JsonLiteral, 'JsonLiteral');
initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
protoOf(defer$1).p11 = get_isNullable;
protoOf(defer$1).x11 = get_isInline;
protoOf(defer$1).z11 = get_annotations;
initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForClass(Composer, 'Composer');
initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers');
initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals');
initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint');
initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
initMetadataForClass(JsonException, 'JsonException');
initMetadataForClass(JsonDecodingException, 'JsonDecodingException');
initMetadataForClass(JsonEncodingException, 'JsonEncodingException');
initMetadataForObject(Tombstone, 'Tombstone');
initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
protoOf(JsonSerializersModuleValidator).q1k = contextual;
initMetadataForClass(JsonSerializersModuleValidator, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector]);
initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [1]);
initMetadataForClass(Key, 'Key', Key);
initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder]);
initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes');
initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder]);
initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, VOID, [JsonDecoder]);
initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder');
initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder');
initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder');
initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder');
initMetadataForClass(WriteMode, 'WriteMode');
initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
initMetadataForObject(CharMappings, 'CharMappings');
initMetadataForClass(StringJsonLexer, 'StringJsonLexer');
initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments');
initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Tombstone_instance = new Tombstone();
//endregion
//region block: exports
export {
  Default_getInstance as Default_getInstanceqol46f1ssq2p,
  JsonBuilder as JsonBuildere7k0u736arkf,
  Json_0 as Jsonsmkyu9xjl7fv,
  Json as Json1n3ogdvkni9sh,
};
//endregion
